import styled from 'styled-components';

const StyledAccordionSingle = styled.div`
  position: relative;
  width: 100%;
  .accordion--single {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .accordion--title-wrap{
    position: relative;
    width: 100%;
    display:flex;
    align-items: flex-start;
    justify-content: space-betweeen;
    padding-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  .accordion--title-wrap h6 {
    flex: 1 1 auto;
    text-align: left;
  }
  .accordion--icon{
    position: relative;
    flex: 0 0 80px;
    width: 80px;
    height: 40px;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .accordion--icon .line{
    position: relative;
    border-bottom: 2px solid #4C796C;
    width: 25px;
    margin-right: 10px;
    margin-left: auto;
    opacity: 1;
    transition: transform .5s, opacity .5s;
  }
  .accordion--icon .line:nth-child(1){
    position: absolute;
    right: 0;
    transform: rotate(90deg);
  }
  .accordion--open.accordion--icon .line:nth-child(1) {
    transform: rotate(180deg);
  }
  .accordion--open.accordion--icon .line:nth-child(2) {
    transform: rotate(90deg);
    opacity: 0;
  }
  .accordion--content{
    position: relative;
    width: 100%;
    text-align:left;
    height: 0;
    overflow: hidden;
    transition: height .5s;
  }
  .accordion--content-double .accordion--height{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    .accordion--title-wrap{
      padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
    .accordion--icon{
      flex: 0 0 60px;
      width: 60px;
    }
  }
  @media screen and (max-width: 767px){
    .accordion--title-wrap{
      padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    .accordion--icon{
      flex: 0 0 44px;
      width: 44px;
    }
    .accordion--content-double .accordion--height{
      flex-direction: column;
    }
  }
`;

export {
  StyledAccordionSingle,
};

